import { TextField } from '@material-ui/core';
import React from 'react';

const LangTB = ({label, value, change}) => {

    return <TextField label={label} variant="outlined" value={value} onChange={(e) => change(e.target.value)} fullWidth />
}

export default LangTB;
